// Company name mappings for tooltips
export const COMPANY_NAMES: Record<string, string> = {
  // Tech Giants
  'AAPL': 'Apple Inc.',
  'MSFT': 'Microsoft Corporation',
  'GOOGL': 'Alphabet Inc. (Class A)',
  'GOOG': 'Alphabet Inc. (Class C)',
  'AMZN': 'Amazon.com Inc.',
  'META': 'Meta Platforms Inc.',
  'NVDA': 'NVIDIA Corporation',
  'TSLA': 'Tesla Inc.',
  'AVGO': 'Broadcom Inc.',
  'ORCL': 'Oracle Corporation',
  'ADBE': 'Adobe Inc.',
  'CRM': 'Salesforce Inc.',
  'INTC': 'Intel Corporation',
  'AMD': 'Advanced Micro Devices Inc.',
  'NFLX': 'Netflix Inc.',
  
  // ETFs
  'SPY': 'SPDR S&P 500 ETF Trust',
  'QQQ': 'Invesco QQQ Trust',
  'VOO': 'Vanguard S&P 500 ETF',
  'VTI': 'Vanguard Total Stock Market ETF',
  'IVV': 'iShares Core S&P 500 ETF',
  'VEA': 'Vanguard FTSE Developed Markets ETF',
  'VWO': 'Vanguard FTSE Emerging Markets ETF',
  'AGG': 'iShares Core U.S. Aggregate Bond ETF',
  
  // Financial
  'JPM': 'JPMorgan Chase & Co.',
  'BAC': 'Bank of America Corporation',
  'WFC': 'Wells Fargo & Company',
  'GS': 'Goldman Sachs Group Inc.',
  'MS': 'Morgan Stanley',
  'V': 'Visa Inc.',
  'MA': 'Mastercard Incorporated',
  'BRK.B': 'Berkshire Hathaway Inc. (Class B)',
  
  // Healthcare
  'UNH': 'UnitedHealth Group Incorporated',
  'JNJ': 'Johnson & Johnson',
  'LLY': 'Eli Lilly and Company',
  'PFE': 'Pfizer Inc.',
  'ABBV': 'AbbVie Inc.',
  'TMO': 'Thermo Fisher Scientific Inc.',
  'MRK': 'Merck & Co. Inc.',
  
  // Consumer
  'WMT': 'Walmart Inc.',
  'HD': 'The Home Depot Inc.',
  'PG': 'Procter & Gamble Company',
  'KO': 'The Coca-Cola Company',
  'PEP': 'PepsiCo Inc.',
  'COST': 'Costco Wholesale Corporation',
  'NKE': 'NIKE Inc.',
  'MCD': "McDonald's Corporation",
  
  // Industrial
  'BA': 'The Boeing Company',
  'CAT': 'Caterpillar Inc.',
  'GE': 'General Electric Company',
  'MMM': '3M Company',
  
  // Energy
  'XOM': 'Exxon Mobil Corporation',
  'CVX': 'Chevron Corporation',
  
  // Telecom
  'T': 'AT&T Inc.',
  'VZ': 'Verizon Communications Inc.',
  
  // Other
  'DIS': 'The Walt Disney Company',
  'FTNT': 'Fortinet Inc.',
  'NET': 'Cloudflare Inc.',
};

export function getCompanyName(symbol: string): string {
  return COMPANY_NAMES[symbol] || symbol;
}
